import LyShenheStatus from './src/index.vue'

LyShenheStatus.install = function (Vue) {
    Vue.component(LyShenheStatus.name, LyShenheStatus)
}

export default LyShenheStatus



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/shenhe-status/index.js
// module id = null
// module chunks = 